import { RawMoneyComponent } from '@components/Shared/Money';
import { Trans } from '@edreamsodigeo/frontend-core';
import { Body, Box, Pill } from '@edreamsodigeo/prisma-design-system';
import { useNumberOfPassengers } from 'clientState/providers/SearchRequestProvider';
import { Money } from 'generated/graphql';
import React from 'react';

// 30% discount threshold
const DISCOUNT_THRESHOLD = 0.3;
export const PRIME_DISCOUNT_TEST_ID = 'prime-discount-pill';
const PrimeDiscountPillMoney = ({ currency, amount }) => (
  <RawMoneyComponent currency={currency}>{amount}</RawMoneyComponent>
);

export const shouldDisplayPrimePill = (
  noPrimePrice: Money,
  primePrice: Money
) =>
  noPrimePrice.amount - noPrimePrice.amount * DISCOUNT_THRESHOLD >
  primePrice.amount;

export type PrimeDiscountPillProps = {
  primePrice: Money;
  noPrimePrice: Money;
};
export const PrimeDiscountPill: React.FC<PrimeDiscountPillProps> = ({
  primePrice,
  noPrimePrice,
}) => {
  const passengers = useNumberOfPassengers();
  const shouldDisplayPill = shouldDisplayPrimePill(noPrimePrice, primePrice);
  const discountAmount =
    Math.round(noPrimePrice.amount - primePrice.amount) * passengers;

  return shouldDisplayPill ? (
    <Box marginTop="2x_small" data-testid={PRIME_DISCOUNT_TEST_ID}>
      <Pill
        rounded
        type="deals"
        sx={{
          paddingLeft: '2x_small',
          paddingRight: '2x_small',
        }}
      >
        <Body type="xxSmall" weight="medium" whiteSpace="nowrap">
          <Trans
            i18nKey="prime.pill.text"
            components={{
              moneySaved: (
                <PrimeDiscountPillMoney
                  currency={primePrice.currency}
                  amount={discountAmount}
                />
              ),
            }}
          />
        </Body>
      </Pill>
    </Box>
  ) : null;
};
